<template>
  <div>
    <b-row>
      <b-col cols="3">
        <h-m-icon v-model="actualNav" :nav-choices="navChoices" name="graph-style"></h-m-icon>
      </b-col>
    </b-row>
    <b-row class="my-4 align-items-center">
      <b-col class="d-flex" cols="4">
        <h-b-action
          :positive="false"
          icon="bx bx-slider-alt"
          text="Filtres"
          @click.native="handleFilterClick"
        ></h-b-action>
      </b-col>
      <b-col cols="4" class="d-flex justify-content-center">
        <h-b-dropdown-select v-model="actualCategory" :options="categoryChoices" class="w-50"></h-b-dropdown-select>
      </b-col>
      <b-col cols="4">
        <b-row class="d-flex justify-content-end w-100">
          <b-col cols="6">
            <h-m-styled-plaintext
              v-model="actualDataType"
              :nav-choices="dataTypeChoices"
              name="data-type"
            ></h-m-styled-plaintext>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="align-items-center">
      <b-col cols="3">
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <h-r-informations v-model="informations[actualCategory]" title="Informations affichées"></h-r-informations>
      </b-col>
      <b-col cols="9">
        <apexchart
          v-if="actualNav !== 'list'"
          :key="chartKey"
          :options="chartOptions"
          :series="series"
          :type="actualNav"
          height="450"
        ></apexchart>
        <h-t-table v-else>
          <template #table-head>
            <h-t-table-header>Information</h-t-table-header>
            <h-t-table-header>{{ formatTableHeader }}</h-t-table-header>
          </template>
          <template #table-body>
            <tr v-for="item in series" :key="item.name">
              <h-t-table-element>{{ item.name }}</h-t-table-element>
              <h-t-table-element>{{ formatSum(item.data) }}</h-t-table-element>
            </tr>
          </template>
        </h-t-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Reporting } from '@/node-sdk'
import axios from 'axios'

export default {
  name: 'crm-reporting',

  props: {
    categoryChoices: {
      type: Array,
      required: true,
    },
    informations: {
      type: Object,
      required: true,
    },
    dataTypeChoices: {
      type: Array,
      required: true,
    },
    formFilters: {
      type: Object,
      required: true,
    },
    activeFilters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      actualNav: 'line',
      navChoices: [
        { icon: 'mdi mdi-chart-bell-curve-cumulative mdi-18px', link: 'line', active: false, name: 'Courbes' },
        { icon: 'mdi mdi-chart-bar mdi-18px', link: 'bar', active: false, name: 'Diagrammes en bâtons' },
        { icon: 'mdi mdi-format-list-bulleted mdi-18px', link: 'list', active: false, name: 'Listes' },
      ],
      actualCategory: 'sales',
      series: [],
      chartOptions: Reporting.getChartParams(),
      actualDataType: 'total',
      yaxis: Reporting.getYAxisDataType(),
      chartKey: 0,
    }
  },

  computed: {
    formatTableHeader() {
      return this.dataTypeChoices.find((dataTypeChoices) => dataTypeChoices.link === this.actualDataType).text
    },
  },

  watch: {
    informations: {
      deep: true,
      async handler() {
        await this.getChart()
      },
    },

    async actualCategory() {
      this.series = []
      await this.getChart()
      this.$emit('changeCategory', this.actualCategory)
    },

    actualNav() {
      if (this.actualNav !== 'list') {
        this.chartKey += 1
      }
    },

    async actualDataType() {
      await this.getChart()
    },

    formFilters: {
      deep: true,
      async handler() {
        await this.getChart()
      },
    },

    activeFilters: {
      deep: true,
      async handler() {
        await this.getChart()
      },
    },
  },

  methods: {
    async getChart() {
      const request = Reporting.formatRequestQuery(
        this.informations[this.actualCategory],
        this.actualDataType,
        this.formFilters,
        this.activeFilters,
      )
      const response = await axios.get(`${process.env.VUE_APP_COMMERCIAL_API}${this.actualCategory}/${request}`)
      this.series = response.data.series
      this.chartOptions.xaxis.categories = response.data.xaxis
      this.chartOptions.yaxis = this.yaxis[this.actualDataType]
      this.chartOptions.colors = Reporting.formatColors(this.informations[this.actualCategory])
      this.chartKey += 1
    },

    formatSum(data) {
      let result = 0
      data.forEach((number) => {
        result += number
      })
      return result
    },

    handleFilterClick() {
      this.$emit('clickFilter')
    },
  },
}
</script>

<style scoped></style>
